<nz-modal
    [(nzVisible)]="isVisible"
    [nzMaskClosable]="false"
    nzTitle="Progress"
    nzClassName="custom-modal"
    [nzFooter]="null"
    nzWidth="900px"
    (nzOnCancel)="close()"
>
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="loading">
            <div class="export-btn">
                <button nz-button nzType="default" (click)="back()" *ngIf="hasClickDetail||hasClickReport">
                    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>Back
                </button>
                <button nz-button nzType="default" class="text-btn-primary" *ngIf="!(hasClickDetail || hasClickReport)"
                        (click)="report()">Report
                </button>
                <button nz-button nzType="default" class="text-btn-primary" *ngIf="hasClickReport" (click)="send()">
                    Send
                </button>
                <button nz-button nzType="default" class="text-btn-primary" *ngIf="!hasClickReport" (click)="export()">
                    Export
                </button>
            </div>
            <app-test-case-progress *ngIf="!(hasClickDetail || hasClickReport)" [data]="statisticsData"
                                    class="statistics-container"
                                    (toDetail)="detail($event)" [isFromTask]="false"></app-test-case-progress>
            <app-st
                #st
                *ngIf="hasClickDetail"
                [columns]="columns"
                [data]="detailData"
                [loading]="tableLoading"
                [page]="{ show: true }"
                [ps]="size"
                [pi]="page + 1"
                [total]="total"
                [scroll]="nzScroll"
                (changes)="changeData($event)"
                [templates]="{status: status, severity: severity}"
            >
                <ng-template #status let-row>
                    <app-status-tag [status]="row.status"></app-status-tag>
                </ng-template>
                <ng-template #severity let-row>
                    <app-status-tag [status]="row.severity"></app-status-tag>
                </ng-template>
            </app-st>

            <app-st
                #st
                *ngIf="hasClickReport"
                [columns]="reportColumns"
                [data]="reportData"
                [loading]="tableLoading"
                [page]="{ show: false }"
                [scroll]="{y: '600px'}"
                [templates]="{executedRatio: executedRatio, passedRatio: passedRatio}"
            >
                <ng-template #executedRatio let-row>
                    <app-progress
                        class="line-progress"
                        [percent]="formatPercent(row.executedRatio)"
                        [nzType]="'line'"
                        [showInfo]="true"
                        [strokeLinecap]="'square'"
                        [class]="'square-line-progress'"
                        [strokeWidth]="18"
                        [nzStrokeColor]="getProgressColor(row.executedRatio)"
                        [textHasColor]="true"
                    ></app-progress>
                </ng-template>
                <ng-template #passedRatio let-row>
                    <app-progress
                        class="line-progress"
                        [percent]="formatPercent(row.passedRatio)"
                        [nzType]="'line'"
                        [showInfo]="true"
                        [strokeLinecap]="'square'"
                        [class]="'square-line-progress'"
                        [strokeWidth]="18"
                        [nzStrokeColor]="getProgressColor(row.passedRatio)"
                        [textHasColor]="true"
                    ></app-progress>
                </ng-template>
            </app-st>
        </nz-spin>
    </ng-container>
</nz-modal>

<app-send-email #sendEmail [currentUser]="currentUser" [type]="'test-case'"
                [isProjectTestCase]="isProject"></app-send-email>
